<template>
    <div>
        <el-form :model="employeeForm" label-width="100px" class="demo-ruleForm" v-loading="loading">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="员工姓名"  >
                        <el-input v-if="is_edit" v-model="employeeForm.name" ></el-input>
                        <span v-else>{{employee.name}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="手机号码"   >
                        <el-input  v-if="is_edit" v-model="employeeForm.phone"></el-input>
                        <span v-else>{{employee.phone}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生日" >
                        <el-date-picker v-if="is_edit"
                                        v-model="employeeForm.birthday"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <span v-else>{{employee.birthday}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别">
                        <el-radio-group v-if="is_edit" v-model="employeeForm.gender_id">
                            <el-radio :label="1">男生</el-radio>
                            <el-radio :label="2">女生</el-radio>
                        </el-radio-group>
                        <span v-else>{{employee.gender}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="老师">
                        <el-radio-group v-if="is_edit" v-model="employeeForm.is_teacher">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                        <span v-else>{{employee.isTeacher}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班主任">
                        <el-radio-group v-if="is_edit" v-model="employeeForm.is_headTeacher">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                        <span v-else>{{employee.isHeadTeacher}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="教务">
                        <el-radio-group v-if="is_edit" v-model="employeeForm.is_senate">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="2">否</el-radio>
                        </el-radio-group>
                        <span v-else>{{employee.isSenate}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="居住地址" >
                        <el-input v-if="is_edit" v-model="employeeForm.address"></el-input>
                        <span v-else>{{employee.address}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证件类型"  >
                        <el-select  v-if="is_edit" v-model="employeeForm.idCard_type_id" placeholder="请选择">
                            <el-option
                                    v-for="item in filter.idCardTypes"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <template v-else>
                            <!--<span v-if="employee.idCard_type_id!=NULL">{{filter.idCardTypes[employee.idCard_type_id-1].name}}</span>-->
                            <!--<span v-else="employee.idCard_type_id==NULL">{{ }}</span>-->
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证件号"  >
                        <el-input v-if="is_edit" v-model="employeeForm.id_card"></el-input>
                        <span v-else>{{employee.id_card}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入职日期"  >
                        <el-date-picker v-if="is_edit"
                                        v-model="employeeForm.joined_date"
                                        type="date"
                                        placeholder="选择日期">
                        </el-date-picker>
                        <span v-else>{{employee.joined_date}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="职位名称"  >
                        <el-input v-if="is_edit" v-model="employeeForm.position" ></el-input>
                        <span v-else>{{employee.position}}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="菜单权限类型"  >
                        <el-select  v-if="is_edit" v-model="employeeForm.menuPower_id" placeholder="请选择">
                            <el-option
                                    v-for="item in filter.menuPowers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <template v-else>
                            <!--<span v-if="employee.idCard_type_id!=NULL">{{filter.idCardTypes[employee.idCard_type_id-1].name}}</span>-->
                            <!--<span v-else="employee.idCard_type_id==NULL">{{ }}</span>-->
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="功能权限类型"  >
                        <el-select  v-if="is_edit" v-model="employeeForm.pagePower_id" placeholder="请选择">
                            <el-option
                                    v-for="item in filter.pagePowers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <template v-else>
                            <!--<span v-if="employee.idCard_type_id!=NULL">{{filter.idCardTypes[employee.idCard_type_id-1].name}}</span>-->
                            <!--<span v-else="employee.idCard_type_id==NULL">{{ }}</span>-->
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item align="right" >
                <el-button v-if="is_creating||powers.includes(22)" type="primary"  @click="handleStoreEmployee" :loading="button_loading" :disabled="isDisable">创建员工</el-button>
                <template v-else>
                    <el-button v-if="!is_edit||powers.includes(23)" type="primary"  @click="handleEdit">修改信息</el-button>
                    <template v-else>
                        <el-button type="primary"  @click="handleEdit">取消修改</el-button>
                        <el-button type="primary"  @click="handleUpdateEmployee"  :loading="button_loading">保存</el-button>
                    </template>
                </template>
            </el-form-item>
        </el-form>
    </div>
</template>
<style>
</style>

<script>
    import store from '@/store'

    export default {

        data() {
            return {
                employeeForm: {
                    name: '',
                    gender_id:'',
                    address: '',
                    joined_date: '',
                    id_card: '',
                    idCard_type_id: '',
                    birthday: '',
                    phone: '',
                    is_teacher:'',
                    is_headTeacher:'',
                    is_senate:'',
                    position:'',
                    pagePower_id:'',
                    menuPower_id:'',
                    section_id:store.state.config.section
                },
            }
        },
        props:{
            is_creating:{
                default:false
            },
            is_edit:{
                default:false
            },
            id:''
        },
        created() {
            this.handleCreateEmployee();
            //this.handleCreateEmployee();
            if(!this.is_creating){
                this.handleShowEmployee();
            }
        },
        methods:{
            handleShowEmployee(){
                this.$wApi.send(this.path, 'get_employeeDetail', {
                    'id': this.userForm.username,
                    'password': this.userForm.password
                });
                return this.$axios.get(store.state.server + '/employee/' + this.id+'?'+localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.employee = response.data.data.employee;
                    }
                })
            },
            handleCreateEmployee() {
                return this.$axios.get(store.state.server + '/employee/create'+'?'+localStorage.baseUrl).then((response) => {
                    if (response.data.status == 'success') {
                        this.filter.idCardTypes = response.data.data.idCardTypes;
                        this.filter.pagePowers = response.data.data.pagePowers;
                        this.filter.menuPowers = response.data.data.menuPowers;
                    }
                })
            },
            handleUpdateEmployee(){
                this.button_loading=true;
                if(this.employeeForm.joined_date.length !=0){
                    this.employeeForm.joined_date = this.$moment(this.employeeForm.joined_date).format('YYYY-MM-DD');
                }
                this.employeeForm.birthday = this.$moment(this.employeeForm.birthday).format('YYYY-MM-DD')
                this.$axios.put(store.state.server + '/employee/'+this.employee.id+'?'+localStorage.baseUrl,this.employeeForm).then((response) => {
                    if (response.status !='200'){
                        this.button_loading=false;
                    }
                    if (response.data.status == 'success') {
                        this.$emit('result','finished')
                        this.$message({
                            message: '员工修改成功',
                            type: 'success'    });
                        this.is_edit=false;
                        this.employee = response.data.data.employee;
                        this.button_loading=false;
                    }else if (response.data.status == 'error') {
                        this.$message.error('错了哦，' + response.data.msg);
                        this.button_loading=false;
                    }
                })
            },
            // handleCreateEmployee() {
            //     return this.$axios.get(store.state.server + '/employee/create').then((response) => {
            //         if (response.data.status == 'success') {
            //             this.filter.idCardTypes=response.data.data.idCardTypes;
            //         }
            //     })
            // },
            handleStoreEmployee() {
                this.button_loading=true;
                this.employeeForm.joined_date = this.$moment(this.employeeForm.joined_date).format('YYYY-MM-DD')
                this.employeeForm.birthday = this.$moment(this.employeeForm.birthday).format('YYYY-MM-DD')
                this.$axios.post(store.state.server + '/employee'+'?'+localStorage.baseUrl, this.employeeForm).then((response) => {
                    if (response.status !='200'){
                        this.button_loading=false;
                    }
                    if (response.data.status == 'success') {
                        this.$message({
                            message: '员工创建成功',
                            type: 'success'
                        });
                        this.button_loading=false;
                    } else if (response.data.status == 'error') {
                        this.$message.error('错了哦,' + response.data.msg);
                        this.button_loading=false;
                    }
                })

            },
        },
    }
</script>